
















































import Vue, { PropType } from 'vue';
import { OrgPeerGroupBase } from '@/models/orgStructure';
import * as Utils from '@/utils';

import PacketPill from '@/components/PacketPill.vue';
import { BasePacket } from '@/models/packet';

export default Vue.extend({
  components: {
    PacketPill
  },

  props: {
    peerGroup: Object as PropType<OrgPeerGroupBase>
  },

  computed: {
    sortedPackets(): BasePacket[] {
      return this.peerGroup.packets.slice().sort(Utils.sortNamed);
    }
  },

  methods: {
    onPacketClick(packet: BasePacket) {
      const orgId = this.$route.params['organizationId'] as string;

      if (!packet.external) {
        this.$router.push({
          name: 'OrganizationPacket',
          params: {
            organizationId: orgId,
            packetId: `${packet.packetId}`
          }
        });
      } else {
        this.$router.push({
          name: 'PublicPacket',
          params: {
            organizationId: orgId,
            packetId: `${packet.packetId}`
          }
        });
      }
    },

    groupClick() {
      const orgId = this.$route.params['organizationId'] as string;
      this.$router.push({
        name: 'OrganizationPeerGroup',
        params: {
          organizationId: orgId,
          peerGroupId: `${this.peerGroup.peerGroupId}`
        }
      });
    }
  }
});
